import { default as indexDdBdBQruoJMeta } from "D:/code/peergroup/pages/index.vue?macro=true";
import { default as _91id_93zEIL5eMFNJMeta } from "D:/code/peergroup/pages/page/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("D:/code/peergroup/pages/index.vue")
  },
  {
    name: "page-id",
    path: "/page/:id()",
    component: () => import("D:/code/peergroup/pages/page/[id].vue")
  }
]